<template>
	<div>
		<core-layout-headline-with-tabs :tabs="tabs">
			{{ $t("course_detail") }}
		</core-layout-headline-with-tabs>
		<core-layout-content full>
			<!-- Language selector -->
			<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
				<div class="pr2 xs-12 fs3 lh125 fw7 pb1">{{ $t("language") }}</div>
				<core-select-locale
					class="xs-12"
					size="xsmall"
					v-model="selectedLocale"
				/>
			</div>

			<!-- Spinner -->
			<div v-if="isLoading" class="xs-12 flex xs-middle xs-center p4">
				<j-spinner />
			</div>

			<!-- Credentials-->
			<course-detail-credentials
				:course="course"
				:selectedLocale="selectedLocale"
				@course:updated="fetchCourse"
			/>
		</core-layout-content>
	</div>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"
import CourseDetailCredentials from "../components/CourseDetailCredentials"
import JSpinner from "@/components/JSpinner"

import api from "@/api/gql.js"
import { i18n } from "@/locales/setup.js"
import queries from "../utils/queries.js"

export default {
	props: {
		id: String
	},

	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineWithTabs,
		CourseDetailCredentials,
		CoreSelectLocale,
		JSpinner
	},

	data() {
		return {
			course: null,
			selectedLocale: i18n.locale,
			tabs: [
				{
					id: "overview",
					name: this.$t("overview"),
					to: { name: "CourseDetail", params: { ...this.$route.params } }
				},
				{
					id: "content",
					name: this.$t("content"),
					to: {
						name: "CourseContent",
						params: { ...this.$route.params }
					}
				}
			]
		}
	},

	methods: {
		async fetchCourse() {
			this.isLoading = true
			const res = await api({
				locale: this.selectedLocale,
				query: queries.fetchCourse,
				variables: {
					where: { id: this.id }
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors && res?.errors?.length)
				this.$store.dispatch("showError", [res.errors?.[0]?.message])

			this.course = res?.data?.courses?.list[0]
		}
	},

	created() {
		this.fetchCourse()
	},

	watch: {
		selectedLocale: {
			handler(o, n) {
				if (o && n) {
					this.fetchCourse()
				}
			}
		}
	}
}
</script>
